import { render, staticRenderFns } from "./BhBackgroundGad.vue?vue&type=template&id=75811108"
import script from "./BhBackgroundGad.vue?vue&type=script&lang=js"
export * from "./BhBackgroundGad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports